(function(){
'use strict';
/* Stock-state switch — mirrors {% assign cti_oos %} / {% assign cti_preorder %} in
   page.custotag-for-ios-v3.liquid (ported from ct-and-v3-lp.js 25-09-26). Under OOS the
   template already renders both ATC buttons disabled (addToCart bails on btns[0].disabled);
   under PREORDER the buttons work normally and only the copy changes. These flags exist to
   keep the two strings this file writes at runtime — the per-tag line and the ATC label —
   honest, because both would otherwise overwrite the template's wording on first render.
   Driven by the template, never hand-edited here: flip the flags in the page template and
   this follows. */
const OOS_EL=document.getElementById('ct-lp-ios-v3');
const OOS=OOS_EL?.dataset.oos==='true';
const OOS_BACK=OOS_EL?.dataset.oosBack||'';
const PREORDER=OOS_EL?.dataset.preorder==='true';
const SHIP_FROM=OOS_EL?.dataset.ship||'';
/* CustoTag iOS LP v3 — same cart mechanics as ct-ios-lp.js, new chip-style buy card.
   Pack variant IDs and prices from landing-pages/PLAYBOOK.md (iOS reference data).
   MRPs from project-data/products.md; Pack of 8 MRP is a flagged data error, so no
   strike-through/off% is shown for it. */
const PACKS=[
  {label:'Pack of 1',qty:1,price:679,mrp:1999,variantId:47850416242907},
  {label:'Pack of 2',qty:2,price:1249,mrp:3998,variantId:47850419683547,badge:'Popular'},
  {label:'Pack of 3',qty:3,price:1799,mrp:5997,variantId:47850420535515},
  {label:'Pack of 4',qty:4,price:2299,mrp:7996,variantId:47850420568283},
  {label:'Pack of 6',qty:6,price:3299,mrp:11994,variantId:47850420666587},
  {label:'Pack of 8',qty:8,price:3999,mrp:15992,variantId:48039760789723,badge:'Best Value'}
];
/* Prices above are a FALLBACK only. The page template renders #ct-live-prices from the real
   Shopify products; those win. Keeps the LP from drifting when a price changes (21.08.26). */
(function syncLivePrices(){
  try{
    var el=document.getElementById('ct-live-prices');
    if(!el) return;
    var byId={};
    JSON.parse(el.textContent||'[]').forEach(function(r){ byId[r.vid]=r; });
    PACKS.forEach(function(p){
      var r=byId[p.variantId];
      if(!r||!(r.price>0)) return;
      p.price=r.price;
      if(r.mrp>p.price) p.mrp=r.mrp;
    });
  }catch(e){}
})();
const SIL_COLORS=[
  {name:'Black',variantId:47851440308443,hex:'#1a1a1a',price:120},
  {name:'Navy Blue',variantId:47851440341211,hex:'#1e3a5f',price:120},
  {name:'White',variantId:47851440373979,hex:'#f0f0f0',price:120,border:true},
  {name:'Baby Pink',variantId:47851440406747,hex:'#f4a7b9',price:120}
];
const COL_COLORS=[
  {name:'Black',variantId:48163991650523,hex:'#1a1a1a',price:120},
  {name:'Sky Blue',variantId:48164004004059,hex:'#87CEEB',price:120},
  {name:'White',variantId:48163991716059,hex:'#f0f0f0',price:149,border:true},
  {name:'Baby Pink',variantId:48163991748827,hex:'#f4a7b9',price:149}
];
const BAT_VID=47851464163547,BAT_PRICE=350;
const CAROUSEL_IMGS=[
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/IOS_Custotag_1.jpg?v=1786450434',
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/cti-lp-silicone-case-180926.jpg?v=1789730263',
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/cti-lp-size-180926.jpg?v=1789730264',
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/CustoTag_Android_8.jpg?v=1770361488',
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/cti-lp-battery-subscription-180926.webp?v=1789730328',
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/cti-lp-resetting-180926.webp?v=1789730328'
];
let selectedPack=1;
let silQtys=[0,0,0,0];
let colQtys=[0,0,0,0];
let bat={on:false,qty:1};
let carouselIdx=0,carouselTimer;
const fmt=n=>'₹'+n.toLocaleString('en-IN');
/* ceil, not round: per-tag must never read LOWER than the true figure or it
   overstates the deal (same principle as the floored discount rule). */
const perUnit=p=>Math.ceil(p.price/p.qty);
const offPct=p=>p.mrp?Math.floor((1-p.price/p.mrp)*100):null;

function buildPackChips(){
  const el=document.getElementById('ct-v3-pack-chips');
  if(!el)return;
  el.innerHTML=PACKS.map((p,i)=>`
    <button class="ct-v3-pack-chip${i===selectedPack?' selected':''}" data-i="${i}" type="button">
      ${p.badge?`<span class="ct-v3-pack-chip-badge">${p.badge}</span>`:''}
      <span class="ct-v3-pack-chip-n">${p.qty} tag${p.qty>1?'s':''}</span>
      <span class="ct-v3-pack-chip-price">${fmt(p.price)}</span>
      <span class="ct-v3-pack-chip-per">${p.qty>1?fmt(perUnit(p))+'/tag':'&nbsp;'}</span>
    </button>
  `).join('');
  el.querySelectorAll('.ct-v3-pack-chip').forEach(c=>{
    c.addEventListener('click',()=>{
      selectedPack=+c.dataset.i;
      el.querySelectorAll('.ct-v3-pack-chip').forEach(x=>x.classList.remove('selected'));
      c.classList.add('selected');
      updateTotal();
    });
  });
}

function buildColorGrid(gridId,colors,qtysArr){
  const el=document.getElementById(gridId);
  if(!el)return;
  el.innerHTML=colors.map((c,i)=>`
    <div class="ct-v3-color-row${qtysArr[i]>0?' active':''}" data-i="${i}">
      <div class="ct-v3-color-dot" style="background:${c.hex}${c.border?';box-shadow:inset 0 0 0 1.5px #ccc':''}"></div>
      <span class="ct-v3-color-name">${c.name}</span>
      <span class="ct-v3-color-row-price">${fmt(c.price)}</span>
      <div class="ct-v3-color-qty-wrap">
        <button class="ct-v3-qty-btn ct-v3-cminus" data-grid="${gridId}" data-i="${i}" type="button">&#8722;</button>
        <span class="ct-v3-qty-val" id="${gridId}-v-${i}">${qtysArr[i]}</span>
        <button class="ct-v3-qty-btn ct-v3-cplus" data-grid="${gridId}" data-i="${i}" type="button">+</button>
      </div>
    </div>
  `).join('');
  el.querySelectorAll('.ct-v3-cminus').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const i=+btn.dataset.i;
      if(qtysArr[i]>0){
        qtysArr[i]--;
        document.getElementById(`${gridId}-v-${i}`).textContent=qtysArr[i];
        btn.closest('.ct-v3-color-row').classList.toggle('active',qtysArr[i]>0);
        updateTotal();
      }
    });
  });
  el.querySelectorAll('.ct-v3-cplus').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const i=+btn.dataset.i;
      qtysArr[i]++;
      document.getElementById(`${gridId}-v-${i}`).textContent=qtysArr[i];
      btn.closest('.ct-v3-color-row').classList.add('active');
      updateTotal();
    });
  });
}

function initCheck(id,state){
  const el=document.getElementById(id);
  if(!el)return;
  const toggle=()=>{
    state.on=!state.on;
    el.classList.toggle('checked',state.on);
    el.innerHTML=state.on?'<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="2,8 6,12 14,4"/></svg>':'';
    updateTotal();
  };
  el.addEventListener('click',toggle);
  el.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}});
}

function initQty(minId,plusId,valId,state){
  const m=document.getElementById(minId),p=document.getElementById(plusId),v=document.getElementById(valId);
  if(!m||!p||!v)return;
  m.addEventListener('click',()=>{if(state.qty>1){state.qty--;v.textContent=state.qty;updateTotal();}});
  p.addEventListener('click',()=>{state.qty++;v.textContent=state.qty;updateTotal();});
}

function updateTotal(){
  const pk=PACKS[selectedPack];
  let total=pk.price;
  let rows=`<div class="ct-v3-order-row"><span>${pk.label}</span><span>${fmt(pk.price)}</span></div>`;
  SIL_COLORS.forEach((c,i)=>{
    if(silQtys[i]>0){const t=c.price*silQtys[i];total+=t;rows+=`<div class="ct-v3-order-row"><span>Silicone Case – ${c.name} ×${silQtys[i]}</span><span>${fmt(t)}</span></div>`;}
  });
  COL_COLORS.forEach((c,i)=>{
    if(colQtys[i]>0){const t=c.price*colQtys[i];total+=t;rows+=`<div class="ct-v3-order-row"><span>Collar Case – ${c.name} ×${colQtys[i]}</span><span>${fmt(t)}</span></div>`;}
  });
  if(bat.on){const t=BAT_PRICE*bat.qty;total+=t;rows+=`<div class="ct-v3-order-row"><span>Battery Subscription ×${bat.qty}</span><span>${fmt(t)}</span></div>`;}
  rows+=`<div class="ct-v3-order-row total"><span>Total</span><span>${fmt(total)}</span></div>`;
  const sum=document.getElementById('ct-v3-order-summary');
  if(sum)sum.innerHTML=rows;
  // price block reflects the selected pack (not add-ons)
  const now=document.getElementById('ct-v3-price-now');
  const mrp=document.getElementById('ct-v3-price-mrp');
  const off=document.getElementById('ct-v3-price-off');
  const per=document.getElementById('ct-v3-price-per');
  if(now)now.textContent=fmt(pk.price);
  if(mrp){mrp.textContent=pk.mrp?fmt(pk.mrp):'';mrp.style.display=pk.mrp?'':'none';}
  if(off){off.textContent=pk.mrp?offPct(pk)+'% off':'';off.style.display=pk.mrp?'':'none';}
  if(per)per.textContent=pk.qty>1?fmt(perUnit(pk))+' per tag':(OOS?'Pre-order opens '+OOS_BACK:PREORDER?'Ships from '+SHIP_FROM:'Ships in 24 hours');
  // ATC button carries the live total
  const atc=document.getElementById('ct-v3-atc-btn');
  if(atc&&!atc.disabled)atc.innerHTML=(PREORDER?'Pre-order Now · ':'Add to Cart · ')+fmt(total);
  const sLabel=document.getElementById('ct-v3-sticky-atc-label');
  const sPrice=document.getElementById('ct-v3-sticky-atc-price');
  if(sLabel)sLabel.textContent=pk.label;
  if(sPrice)sPrice.textContent=fmt(total);
}

function showToast(msg){
  let t=document.getElementById('ct-v3-toast');
  if(!t){t=document.createElement('div');t.id='ct-v3-toast';t.className='ct-v3-toast';document.body.appendChild(t);}
  t.innerHTML=msg;t.classList.add('show');
  setTimeout(()=>t.classList.remove('show'),4500);
}

/* Open the theme's slide-out cart after an add.
   The 13-08-26 cart redesign put the drawer behind <modal-trigger target="CART">
   (assets/modal.js). The five selectors this used to look for — data-cart-toggle,
   data-drawer-toggle, #CartToggle, .js-cart-open, [aria-label="Cart"] — match NOTHING on
   the current theme, so the lookup returned null and the drawer silently never opened
   while the item went in fine. They stay only as a fallback.
   Second trap: modal-popup._initCart() fetches /cart ONCE at page load and caches the
   detached <main-cart> node, so it is stale the moment we add. Refresh it first —
   main-cart.update() calls its callback unconditionally, so it must be passed one. */
function openCartDrawer(){
  const mp=document.querySelector('modal-popup[enable-cart]');
  const cart=mp&&mp.cartContent;
  if(cart&&typeof cart.update==='function'){try{cart.update(function(){});}catch(e){}}
  const toggle=document.querySelector('modal-trigger[target="CART"]')
    ||document.querySelector('[data-cart-toggle],[data-drawer-toggle="cart"],#CartToggle,.js-cart-open,[aria-label="Cart"]');
  /* the trigger's own handler bails on a missing cartContent, so don't claim success */
  if(toggle&&cart){toggle.click();return true;}
  return false;
}

async function addToCart(){
  const btns=['ct-v3-atc-btn','ct-v3-sticky-atc-btn'].map(id=>document.getElementById(id)).filter(Boolean);
  if(!btns.length||btns[0].disabled)return;
  const origs=btns.map(b=>b.innerHTML);
  btns.forEach(b=>{b.disabled=true;b.textContent='Adding...';});
  const items=[{id:PACKS[selectedPack].variantId,quantity:1}];
  /* v3/v5 split (16-10-26): tag the pack line with the arm so orders can be read by page.
     window.ctLpArm is set by snippets/ct-lp-split.liquid; null when the test is off. */
  if(window.ctLpArm==='v3')items[0].properties={_lp:'v3',_lp_os:'ios'};
  SIL_COLORS.forEach((c,i)=>{if(silQtys[i]>0)items.push({id:c.variantId,quantity:silQtys[i]});});
  COL_COLORS.forEach((c,i)=>{if(colQtys[i]>0)items.push({id:c.variantId,quantity:colQtys[i]});});
  if(bat.on)items.push({id:BAT_VID,quantity:bat.qty});
  try{
    const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    if(!r.ok)throw new Error();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:added'));
    openCartDrawer();
    showToast('Added to cart! <a href="/cart">View Cart →</a>');
  }catch(e){
    showToast('Something went wrong. Please try again.');
  }finally{
    btns.forEach((b,i)=>{b.disabled=false;b.innerHTML=origs[i];});
    updateTotal();
  }
}

function initFAQ(){
  document.querySelectorAll('.ct-v3-faq-item').forEach(item=>{
    item.querySelector('.ct-v3-faq-q')?.addEventListener('click',()=>{
      const open=item.classList.contains('open');
      document.querySelectorAll('.ct-v3-faq-item.open').forEach(i=>i.classList.remove('open'));
      if(!open)item.classList.add('open');
    });
  });
}

function initModal(){
  const overlay=document.getElementById('ct-v3-modal');
  const video=document.getElementById('ct-v3-modal-video');
  document.querySelectorAll('[data-open-video]').forEach(b=>b.addEventListener('click',()=>{
    overlay?.classList.add('open');video?.play();
  }));
  document.getElementById('ct-v3-modal-close')?.addEventListener('click',()=>{
    overlay?.classList.remove('open');if(video){video.pause();video.currentTime=0;}
  });
  overlay?.addEventListener('click',e=>{
    if(e.target===overlay){overlay.classList.remove('open');if(video){video.pause();video.currentTime=0;}}
  });
}

function goTo(i){
  carouselIdx=i;
  const track=document.getElementById('ct-v3-carousel-track');
  if(track)track.style.transform=`translateX(-${i*100}%)`;
  document.querySelectorAll('.ct-v3-carousel-dot').forEach((d,j)=>d.classList.toggle('active',j===i));
  clearInterval(carouselTimer);
  startAuto();
}
function startAuto(){carouselTimer=setInterval(()=>goTo((carouselIdx+1)%CAROUSEL_IMGS.length),3500);}
function initCarousel(){
  const track=document.getElementById('ct-v3-carousel-track');
  const dotsEl=document.getElementById('ct-v3-carousel-dots');
  if(!track||!dotsEl)return;
  track.innerHTML=CAROUSEL_IMGS.map((src,i)=>`<div class="ct-v3-carousel-slide"><img src="${src}" alt="CustoTag for iOS"${i===0?' loading="eager"':' loading="lazy"'}></div>`).join('');
  dotsEl.innerHTML=CAROUSEL_IMGS.map((_,i)=>`<button class="ct-v3-carousel-dot${i===0?' active':''}" data-i="${i}" aria-label="Slide ${i+1}" type="button"></button>`).join('');
  dotsEl.querySelectorAll('.ct-v3-carousel-dot').forEach(d=>d.addEventListener('click',()=>goTo(+d.dataset.i)));
  document.getElementById('ct-v3-carousel-prev')?.addEventListener('click',()=>goTo((carouselIdx-1+CAROUSEL_IMGS.length)%CAROUSEL_IMGS.length));
  document.getElementById('ct-v3-carousel-next')?.addEventListener('click',()=>goTo((carouselIdx+1)%CAROUSEL_IMGS.length));
  let startX=0;
  track.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;},{passive:true});
  track.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>40)goTo(dx<0?(carouselIdx+1)%CAROUSEL_IMGS.length:(carouselIdx-1+CAROUSEL_IMGS.length)%CAROUSEL_IMGS.length);});
  startAuto();
}

function initScrollCtas(){
  // smooth-scroll every "pick your pack" CTA back to the hero buy card
  document.querySelectorAll('a[href="#ct-v3-buy"]').forEach(a=>{
    a.addEventListener('click',e=>{
      const buy=document.getElementById('ct-v3-buy');
      if(!buy)return;
      e.preventDefault();
      buy.scrollIntoView({behavior:'smooth',block:'center'});
    });
  });
}

function revealReviews(){
  // Judge.me ships its widget hidden behind an inline <style> its own JS removes on
  // hydration, which is unreliable on custom page templates. Strip it so the cached
  // reviews always show; Judge.me's script still upgrades the widget when it runs.
  document.querySelectorAll('.ct-v3-reviews-jdgm .jdgm-temp-hiding-style').forEach(el=>el.remove());
}

function init(){
  revealReviews();
  buildPackChips();
  buildColorGrid('ct-v3-sil-grid',SIL_COLORS,silQtys);
  buildColorGrid('ct-v3-col-grid',COL_COLORS,colQtys);
  initCheck('ct-v3-bat-check',bat);
  initQty('ct-v3-bat-minus','ct-v3-bat-plus','ct-v3-bat-qty',bat);
  document.getElementById('ct-v3-atc-btn')?.addEventListener('click',addToCart);
  document.getElementById('ct-v3-sticky-atc-btn')?.addEventListener('click',addToCart);
  initFAQ();
  initModal();
  initCarousel();
  initScrollCtas();
  updateTotal();
  const stickyBar=document.getElementById('ct-v3-sticky-atc');
  const buyCard=document.getElementById('ct-v3-buy');
  if(stickyBar&&buyCard){
    new IntersectionObserver(([e])=>{
      stickyBar.classList.toggle('hidden',e.isIntersecting);
    },{threshold:0.1}).observe(buyCard);
  }
}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
})();
